// Live-verified texts (docs/reference/live/timesheet.md, timesheet spec section 12); "(clone)" marks clone texts.
export const s = {
  title: "Timesheet",
  teammates: "Teammates",
  searchTeammates: "Search teammates",
  show: "SHOW",
  statusActive: "Active",
  statusInactive: "Inactive",
  statusAll: "All",
  noTeammates: "No teammates found",
  switched: (name: string) => `Switched to ${name}'s timesheet`,
  compactView: "Compact view",
  previousWeek: "Previous week",
  nextWeek: "Next week",
  projects: (label: string) => `${label}s`,
  total: "Total:",
  selectProject: "Select project",
  selectTaskProject: "Task @Project",
  durationInput: "Time duration input",
  rowActions: "Row actions",
  cellActions: "Edit time details",
  delete: "Delete",
  clearRow: "Clear row",
  addNewRow: "Add new row",
  copyLastWeek: "Copy last week",
  copyActivitiesOnly: "Copy activities only",
  copyActivitiesAndTime: "Copy activities and time",
  copyDisabled: "Available only when this week is empty and last week has time.",
  copySkipped: "Some time entries couldn't be copied because their project or task was archived or deleted.",
  saveAsTemplate: "Save as template",
  templates: "Templates",
  withTime: " - with time",
  apply: "Apply",
  editTemplate: "Edit template",
  deleteTemplate: "Delete template",
  deleteTemplateBody: (name: string) => `Are you sure you want to delete ${name}?`,
  templateInfo: "Template rows",
  createTemplate: "Create template",
  templateName: "Template name",
  saveTimeAlso: "Save time also",
  save: "SAVE",
  cancel: "Cancel",
  deleteUpper: "DELETE",
  templateCreated: "Template has been created",
  templateUpdated: "Template has been updated",
  templateDeleted: "Template has been deleted",
  templateApplied: "Template has been applied",
  applyTemplate: "Apply template",
  applyBody: "Some cells already contain time. How would you like to apply the template?",
  applyAdd: "Add",
  applyAddHelp: "Incorporate time entries from the template with existing ones",
  applyReplace: "Replace",
  applyReplaceHelp: "Overwrite existing time entries with the template's entries",
  applySkip: "Skip",
  applySkipHelp: "Ignore cells where time already exists",
  applyUpper: "APPLY",
  entryCreated: "Time entry has been created",
  entriesUpdated: "Successfully updated 1 time entries",
  entryDeleted: "Time entry has been deleted",
  editDetails: "Tags and more",
  deleteRow: "Delete row",
  deleteRowBody: (label: string, total: string) =>
    `This will delete all time entries for ${label} in this week (${total}).`,
  rowKept: "Some entries couldn't be deleted because they are locked or approved.",
  locked: "Can't edit locked entries. Contact your admin for more information.",
  forceTimer: "Manual time tracking is disabled",
  approvedCell: "Approved",
  pendingCell: "Pending",
  timeOffCell: "Only admins can edit time off and holiday entries.",
  runningCell: "Stop the running timer before editing this cell.",
  selectProjectFirst: "Select project first",
  searchProject: "Search project or client...",
  searchTaskProject: "Search Task @Project or Client...",
  noClient: "NO CLIENT",
  projectsCount: (n: number) => `${n} ${n === 1 ? "Project" : "Projects"}`,
  tasksCount: (n: number) => `${n} ${n === 1 ? "Task" : "Tasks"}`,
  noProjects: "No matching projects",
  noPermission: "You don't have permission to view this timesheet",
  missingBanner: (n: number, d: string) =>
    n === 1
      ? `There is ${n} additional time entry (${d}) without required fields.`
      : `There are ${n} additional time entries (${d}) without required fields.`,
  fix: "Fix",
  dismiss: "Dismiss",
  editTime: "Edit time",
  description: "Description",
  descriptionPlaceholder: "What have you worked on?",
  billable: "Billable",
  yes: "Yes",
  no: "No",
  startTime: "Start time",
  endTime: "End time",
  duration: "Duration",
  entryMenu: "More actions",
  submitForApproval: "SUBMIT FOR APPROVAL",
  submitTitle: "Submit for approval",
  submitChanges: "Submit changes",
  submitChangesTitle: "Submit changes",
  submitUpper: "SUBMIT",
  readyToSubmit: (a: string, b: string) => `Ready to submit ${a} - ${b} for approval?`,
  rejectedWarning:
    "You're about to submit time entries that were previously rejected. Please make sure you adjusted the changes accordingly before submitting for approval.",
  timeLabel: "Time:",
  expensesLabel: "Expenses:",
  submitted: "Timesheet submitted for approval",
  withdrawPending: "Withdraw pending",
  withdrawBody: (range: string) => `Are you sure you want to withdraw your approval request for ${range}?`,
  withdrawUpper: "WITHDRAW",
  withdrawn: "Approval request withdrawn",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  fixFirst: "Fix entries without required fields first",
  holiday: "Holiday",
  printHeader: (name: string, range: string) => `Timesheet: ${name}, ${range}`,
  loadError: "Couldn't load the timesheet.",
  retry: "Try again",
} as const;
